import React from "react";
import ACLStore from "lib/aclStore";

const createAssessmentTransferRouter = (V1Component, V2Component) => {
  const Router = props => {
    const isV2 = ACLStore.can("IsEnabledImportGradebook");
    const Component = isV2 ? V2Component : V1Component;
    return <Component {...props} />;
  };
  Router.displayName = "AssessmentTransferRouter";
  return Router;
};

export default createAssessmentTransferRouter;
